import './ControlButton.scss'

import classNames from 'classnames'
import Duplicate from 'icons/Duplicate'
import Pencil from 'icons/Pencil'
import Plus from 'icons/Plus'
import Trash from 'icons/Trash'
import React, { ButtonHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'

export interface ControlButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string
  size?: 'small' | 'medium'
  variant?: 'add' | 'delete' | 'edit' | 'error' | 'duplicate'
  error?: boolean
}

export default function ControlButton(props: ControlButtonProps) {
  const { className, error, size = 'medium', variant = 'edit', ...otherProps } = props
  const [t] = useTranslation()

  function renderSvg() {
    if (variant === 'duplicate') {
      return <Duplicate />
    }
    if (variant === 'delete') {
      return <Trash />
    }
    if (variant === 'add') {
      return <Plus />
    }

    return <Pencil />
  }

  const mergedClassName = classNames(
    'admin-control-button',
    `admin-control-button--${variant}`,
    `admin-control-button--${size}`,
    className,
    { 'admin-control-button--error': error }
  )

  const title = (() => {
    if (variant === 'add') {
      return t('home.admin.controlButton.add')
    }
    if (variant === 'delete') {
      return t('home.admin.controlButton.delete')
    }
    if (variant === 'edit') {
      return t('home.admin.controlButton.edit')
    }
    if (variant === 'duplicate') {
      return t('home.admin.controlButton.duplicate')
    }
  })()

  return (
    <button className={mergedClassName} title={title} {...otherProps}>
      {renderSvg()}
    </button>
  )
}
